.textFieldCloseButtonWrapper {
  position: absolute;
  right: 0.6rem;
  top: 0.8rem;
}

.formControlWrapper {
  position: relative;
  height: 100%;
}

.formControlPrefix {
  color: var(--color-neutral-not-so-light);
  position: absolute;
  left: 2rem;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  font-size: 1.6rem;
}

.formControlPostfix {
  color: var(--color-neutral-not-so-light);
  position: absolute;
  right: 2rem;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  font-size: 1.6rem;
}

.formControlSquared {
  border: thin solid transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  transition: none !important;
  background: transparent !important;
  -webkit-appearance: none;

  &:active,
  &:focus {
    border: thin solid var(--color-primary-dark);
    box-shadow: none;
  }
}

.formControlWhite {
  border: thin solid transparent;
  border-radius: 0;
  box-shadow: none;
  transition: none;
  background: var(--color-white) !important;
}

.formControlPrefixed {
  padding-left: 3rem !important;
}

.formControlPostfixed {
  padding-right: 3rem !important;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.formControlTransparent {
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  transition: none !important;
  background: transparent !important;
  -webkit-appearance: none;
}
